(() => {
  const groups = [
    ['.section__header', '.section__header-heading', '.section__header-des'],
    ['.sec__rich-text .sec__content-inner', '.sec__content-heading', '.sec__content-des'],
    ['.wj-heading, .wj-contact-heading, .wj-journal-heading', 'h1, h2', ':scope > p'],
    ['.wj-group-head, .wj-section-head, .wj-process-head, .wj-photo-head', 'h2, h3', 'p']
  ];
  const pairs = new Map();
  const measure = (heading, lead) => {
    const text = lead.textContent.trim().replace(/\s+/g, ' ');
    const short = text.length <= 85 && text.split(' ').length <= 12;
    const style = getComputedStyle(heading);
    const size = parseFloat(style.fontSize);
    if (!Number.isFinite(size) || size <= 0) return;
    return [lead, `${Math.max(18, Math.round(size * (short ? 1 : .7)))}px`, style.fontFamily, style.letterSpacing];
  };
  let frame = null;
  const refresh = () => {
    frame = null;
    const measured = [];
    pairs.forEach((lead, heading) => {
      if (!heading.isConnected || !lead.isConnected) {
        observer?.unobserve(heading);
        pairs.delete(heading);
        return;
      }
      const values = measure(heading, lead);
      if (values) measured.push(values);
    });
    measured.forEach(([lead, size, font, tracking]) => {
      lead.classList.add('wj-lead');
      [['--wj-lead-size', size], ['--wj-lead-font', font], ['--wj-lead-tracking', tracking]].forEach(([key, value]) => {
        if (lead.style.getPropertyValue(key) !== value) lead.style.setProperty(key, value);
      });
    });
  };
  const schedule = () => {
    if (frame === null) frame = requestAnimationFrame(refresh);
  };
  const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const scan = () => {
    const root = document.getElementById('MainContent');
    if (!root) return;
    groups.forEach(([containerSelector, headingSelector, leadSelector]) => {
      root.querySelectorAll(containerSelector).forEach(container => {
        const heading = container.querySelector(headingSelector);
        const lead = container.querySelector(leadSelector);
        if (!heading || !lead || !lead.textContent.trim()) return;
        if (lead.querySelector('h1, h2, h3, h4, h5, h6, ul, ol, table, form') || lead.querySelectorAll('p').length > 1) return;
        if (heading.compareDocumentPosition(lead) & Node.DOCUMENT_POSITION_PRECEDING) return;
        pairs.set(heading, lead);
        observer?.observe(heading);
      });
    });
    if (frame !== null) cancelAnimationFrame(frame);
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', scan);
  window.addEventListener('resize', schedule);
  document.fonts?.ready.then(schedule);
})();
